<template>
  <div>
    <b-modal
      id="modal-signation-digital-application"
      size="md"
      centered
      :hide-footer="true"
      ref="addKontoModal"
      no-close-on-backdrop
    >
      <template #modal-title>
        <div class="magenta-title">Kontodaten erfassen</div>
      </template>
      <div>
        <b-alert v-model="hasUnknownError" variant="danger">
          {{ unknownErrorMessage }}
        </b-alert>
        <b-alert v-model="success" variant="success">
          Ihre Kontodaten wurden eingetragen
        </b-alert>
        <validation-observer ref="observer" v-slot="{ passes }">
          <b-form @submit.prevent="passes(onSubmit)">
            <!--<validation-provider vid="kontoart">
              <b-form-group label="Kontoart *">
                <b-form-select
                  v-model="form.kontoartId">
                  <option v-for="art in kontoart" :value="art.id" :key="art.id">
                    {{ art.name }}
                  </option>
                </b-form-select>
              </b-form-group>
            </validation-provider>-->
            <validation-provider vid="bankname" v-slot="{ valid, errors, changed }">
              <b-form-group label="Bankname" label-for="input-bankname">
                <b-form-input
                  v-model="form.bankname"
                  :state="onValidateField(valid, errors, changed)"
                  type="text"
                  placeholder="Banknamen angeben"
                ></b-form-input>
                <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider vid="plzort" v-slot="{ valid, errors, changed }">
              <b-form-group label="Bank PLZ und Ort" label-for="input-bankPlzOrt">
                <b-form-input
                  v-model="form.bankPlzOrt"
                  :state="onValidateField(valid, errors, changed)"
                  type="text"
                  placeholder="PLZ / Ort angeben"
                ></b-form-input>
                <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider vid="iban" rules="required|iban" v-slot="{ valid, errors, changed }">
              <b-form-group label="IBAN *" label-for="input-iban">
                <b-form-input
                  v-model="form.iban"
                  :state="onValidateField(valid, errors, changed)"
                  type="text"
                  placeholder="IBAN angeben"
                  v-mask="'NNNN NNNN NNNN NNNN NNNN NNNN NNNN NNNN NNNN NNNN'"
                ></b-form-input>
                <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider vid="esr" rules="required|esr" v-slot="{ valid, errors, changed }" v-if="form.iban && form.iban.replace(/ /g, '')[4] === '3'">
              <b-form-group label="ESR-Referenznummer *" label-for="input-esr" description="Wird benötigt bei QR-IBAN Nummer">
                <b-form-input
                  v-model="form.esrReferenznummer"
                  :state="onValidateField(valid, errors, changed)"
                  type="text"
                  placeholder="ESR-Referenznummer angeben"
                  v-mask="'NN NNNNN NNNNN NNNNN NNNNN NNNNN'"
                ></b-form-input>
                <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider vid="inhaberName" rules="required" v-slot="{ valid, errors, changed }">
              <b-form-group label="Inhaber Name *" label-for="input-inhaberName">
                <b-form-input
                  v-model="form.inhaberName"
                  :state="onValidateField(valid, errors, changed)"
                  type="text"
                  placeholder="Vorname, Name angeben"
                ></b-form-input>
                <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <b-row>
              <b-col col md="8">
                <validation-provider vid="inhaberStrasse" rules="required" v-slot="{ valid, errors, changed }">
                  <b-form-group label="Strasse *" label-for="input-inhaberStrasse">
                    <b-form-input
                      v-model="form.inhaberStrasse"
                      :state="onValidateField(valid, errors, changed)"
                      type="text"
                      placeholder="Strasse"
                    ></b-form-input>
                    <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col col md="4">
                <validation-provider vid="inhaberNr" rules="required" v-slot="{ valid, errors, changed }">
                  <b-form-group label="Nr. *" label-for="input-inhaberNr">
                    <b-form-input
                      v-model="form.inhaberHausNr"
                      :state="onValidateField(valid, errors, changed)"
                      type="text"
                      placeholder="Nr."
                    ></b-form-input>
                    <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col col md="4">
                <validation-provider vid="inhaberPLZ" rules="required" v-slot="{ valid, errors, changed }">
                  <b-form-group label="PLZ *" label-for="input-inhaberPLZ">
                    <b-form-input
                      v-model="form.inhaberPlz"
                      :state="onValidateField(valid, errors, changed)"
                      type="text"
                      placeholder="PLZ"
                    ></b-form-input>
                    <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col col md="8">
                <validation-provider vid="inhaberOrt" rules="required" v-slot="{ valid, errors, changed }">
                  <b-form-group label="Ort *" label-for="input-inhaberOrt">
                    <b-form-input
                      v-model="form.inhaberOrt"
                      :state="onValidateField(valid, errors, changed)"
                      type="text"
                      placeholder="Ort"
                    ></b-form-input>
                    <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <validation-provider vid="land">
              <b-form-group label="Land *">
                <b-form-select v-model="form.inhaberLandId">
                  <option v-for="country in countries" :value="country.id" :key="country.id">
                    {{ country.name }}
                  </option>
                </b-form-select>
              </b-form-group>
            </validation-provider>
            <b-button class="mt-4" type="submit" variant="primary" disabled v-if="isSubmitting">
              <b-spinner small></b-spinner>
              Kontodaten speichern
            </b-button>
            <b-button class="mt-4" type="submit" variant="primary" v-else>Kontodaten speichern</b-button>
          </b-form>
        </validation-observer>
      </div>
    </b-modal>
    <b-button class="btn btn-green" @mousedown="openModal">Kontodaten eingeben</b-button>
  </div>
</template>

<script>
  import { errorHandler, validateField } from '@/helpers/formHelper.js'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { mapGetters } from 'vuex'

  const getInitialData = () => ({
    form: {
      kontoartId: null,
      bankname: null,
      bankPlzOrt: null,
      iban: null,
      inhaberName: null,
      inhaberStrasse: null,
      inhaberHausNr: null,
      inhaberPlz: null,
      inhaberOrt: null,
      inhaberLandId: null,
      esrReferenznummer: null
    }
  })

  export default {
    data: () => ({
      status: false,
      isSubmitting: false,
      hasUnknownError: false,
      hasError: false,
      unknownErrorMessage: '',
      success: false,
      ...getInitialData()
    }),
    props: {
      gesuchId: {
        type: Number
      },
      projektabschlussModal: {
        type: Boolean
      }
    },
    components: {
      ValidationProvider,
      ValidationObserver
    },
    created () {
      this.getKontoart()
      this.getCountries()
      this.getKonto()
    },
    methods: {
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      },
      onSubmit () {
        this.isSubmitting = true
        this.hasUnknownError = false
        this.hasError = false

        this.form.iban = String(this.form.iban).toUpperCase().replace(/ /g, '')
        this.form.esrReferenznummer = String(this.form.esrReferenznummer).toUpperCase().replace(/ /g, '')
        if (this.form.iban && this.form.iban.replace(/ /g, '')[4] !== '3') {
          this.form.esrReferenznummer = null
        }

        this.$store.dispatch('digitalApplication/KONTO_UPDATE', this.form).then(res => {
          const { errors } = res

          if (errors) {
            this.isSubmitting = false
            return errorHandler(this, errors)
          }
          this.isSubmitting = false
          this.success = true
          setTimeout(() => {
            this.success = false
            this.$refs.addKontoModal.hide()
            if (this.projektabschlussModal) {
              this.$emit('refresh-projektabschluss-modal')
            }
          }, 3000)
        }).catch(err => {
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          this.isSubmitting = false
          console.error(err)
        })
      },
      getKonto () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('digitalApplication/GET_KONTO_BY_GESUCHID', this.gesuchId).then(res => {
          const { errors, data } = res
          if (errors) {
            this.showOverlay = false
            return errorHandler(this, errors)
          }
          Object.assign(this.form, data.konto)
          if (!this.form.kontoartId) {
            this.form.kontoartId = this.kontoart[0].id
          }
          if (!this.form.inhaberLandId) {
            this.form.inhaberLandId = this.countries[0].id
          }
        }).catch(err => {
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      },
      async getKontoart () {
        this.$store.dispatch('codes/GET_CODES_KONTOART').then(res => {
          const { errors } = res
          if (errors) {
            return errorHandler(this, errors)
          }
        }).catch(err => {
          console.error(err)
        })
      },
      async getCountries () {
        this.$store.dispatch('codes/GET_CODES_COUNTRIES').then(res => {
          const { errors } = res
          if (errors) {
            return errorHandler(this, errors)
          }
        }).catch(err => {
          console.error(err)
        })
      },
      openModal () {
        this.$refs.addKontoModal.show()
      }
    },
    computed: {
      checkboxChecked () {
        return !this.status
      },
      ...mapGetters({
        kontoart: 'codes/KONTOART',
        countries: 'codes/COUNTRIES'
      })
    }
  }
</script>

<style lang="scss">
#modal-signation-digital-application {
   padding-left: 0 !important;

  .magenta-title {
    color: $magenta;
    font-weight: $font-weight-bold;
  }
}

.icon-gray {
  background-color: $black-10;
  padding: 3px .5rem .5rem;
  border-radius: 0.5rem;
  margin-right: 0.25rem;
}
</style>
